import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || '/api';

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Profile
export const getProfile = () => api.get('/profile');
export const updateProfile = (data) => api.put('/profile', data);

// Experiences
export const getExperiences = () => api.get('/experiences');
export const createExperience = (data) => api.post('/experiences', data);
export const updateExperience = (id, data) => api.put(`/experiences/${id}`, data);
export const deleteExperience = (id) => api.delete(`/experiences/${id}`);

// Benefits
export const getBenefits = () => api.get('/benefits');
export const updateBenefits = (data) => api.put('/benefits', data);

// Works
export const getWorks = () => api.get('/works');
export const createWork = (data) => api.post('/works', data);
export const reorderWorks = (items) => api.put('/works', { items });
export const updateWork = (id, data) => api.put(`/works/${id}`, data);
export const deleteWork = (id) => api.delete(`/works/${id}`);

// Admin auth
export const getAdminSession = () => api.get('/admin/session');
export const adminLogin = (data) => api.post('/admin/login', data);
export const adminLogout = () => api.post('/admin/logout');
export const uploadImage = (data) => api.post('/uploads/image', data);

export default api;
